import { StringUtility } from "@common/utils";
import { defaultTo } from "lodash";
import { EntityScheduleType, WeekDay } from "@common/models/Enums";

export interface IEntityScheduleOverridePreferenceRequest {
    storeId: number;
    entityId: number;
    entityType: EntityScheduleType | undefined;
    schedulePreferenceOverrideId: number | undefined;
    schedulePreferenceId: number;
    scheduleBlockTypeId: number;
    startTime: string;
    endTime: string;
    dayOfWeek: WeekDay.Day;
    overrideDate: string;
    notes: string | undefined;
    createdBy: string | undefined;
    updatedBy: string | undefined;
    dateCreated: string | undefined;
    dateUpdated: string | undefined;
}

export class EntityScheduleOverridePreferenceRequest implements IEntityScheduleOverridePreferenceRequest {
    storeId: number;
    entityId: number;
    entityType: EntityScheduleType | undefined;
    schedulePreferenceOverrideId: number | undefined;
    schedulePreferenceId: number;
    scheduleBlockTypeId: number;
    startTime: string;
    endTime: string;
    dayOfWeek: WeekDay.Day;
    overrideDate: string;
    notes: string | undefined;
    createdBy: string | undefined;
    updatedBy: string | undefined;
    dateCreated: string | undefined;
    dateUpdated: string | undefined;

    constructor(init: Partial<IEntityScheduleOverridePreferenceRequest>) {
        this.storeId = defaultTo(init.storeId, 0);
        this.schedulePreferenceOverrideId = init.schedulePreferenceOverrideId;
        this.entityId = defaultTo(init.entityId, 0);
        this.entityType = init.entityType;
        this.schedulePreferenceId = defaultTo(init.schedulePreferenceId, 0);
        this.scheduleBlockTypeId = defaultTo(init.scheduleBlockTypeId, 0);
        this.startTime = defaultTo(init.startTime, '12:00:00');
        this.endTime = defaultTo(init.endTime, '12:30:00');
        this.dayOfWeek = defaultTo(init.dayOfWeek as WeekDay.Day, WeekDay.Day.Monday);
        this.overrideDate = defaultTo(init.overrideDate, '');
        this.notes = StringUtility.SanitizeString(init.notes);
        this.createdBy = defaultTo(init.createdBy, '');
        this.updatedBy = defaultTo(init.updatedBy, '');
        this.dateCreated = defaultTo(init.dateCreated, '');
        this.dateUpdated = defaultTo(init.dateUpdated, '');
    }
}
